import { mergeDeep } from '../src/common/extensions';

const localConfig = require('./config.json');

export const config = {
  apiAddress: 'http://localhost:3000/api/',
  socketIOAddress: 'http://localhost:3000',
  imageServeUrl: 'http://localhost:3000/imgs/',
  assetImageServeUrl: 'https://imgoingcalendar.com/',
  domain: 'https://imgoingcalendar.com/',  
  serverDomain: 'https://imgoingcalendar.com/',
  serverDomainV3: 'https://next.imgoingcalendar.com/',
  //assetImageServeUrl: 'http://localhost:4200/',
  // apiAddress: 'https://api.imgoingcalendar.com/api/',
  // socketIOAddress: 'https://api.imgoingcalendar.com/',
  // imageServeUrl: 'https://api.imgoingcalendar.com/imgs/',
  defaultLogoUrl: 'assets/imgs/ImGoingLogo-2018-3.png', //'assets/imgs/logo.jpg',
  newDesignLogoUrl: 'assets/imgs/logo2.png', //'assets/imgs/logo.jpg',
  fbLogo: 'assets/imgs/facebook.png',
  googleLogo: 'assets/imgs/google.png',
  defaultImageUrl: 'assets/imgs/new_placeholder_image.jpg',
  sidebarImageUrl: 'assets/imgs/sidebar.jpg',
  topbarImageUrl: 'assets/imgs/topbar.jpg',
  defaultImageDirectory: 'assets/imgs/default/',
  defaultVisitorPromotionImageUrl: 'assets/imgs/sidebar_bottom.jpg',
  eventPositionImage: 'assets/imgs/ImGoingLogo-2018-2.png',
  louisaVALogo: 'assets/imgs/LouisaVA-Logo-PNG.png',
  tripPlannerMapMarker: 'assets/imgs/tp-marker.png',
  tripPlannerMapMarkerNoOverlap: 'assets/imgs/tp-marker-2.png',
  detailSelectedMapMarker: 'assets/imgs/detail_map_icon.png',
  tripPlannerWelcomeImg: 'assets/imgs/tp-bg.jpg',
  tripPlannerTourSideImg: 'assets/imgs/itinerary-new-image.jpg',
  mapImg: 'assets/imgs/map.jpg',
  arrow: 'assets/imgs/arrow.png',
  downwardArrow: 'assets/imgs/gif-bounce-arrow.gif',
  uploadCsvEventsExample: 'assets/pages/Upload-Events-Example.xlsx',
  _360VideoUrl: 'https://cloud.threshold360.com/embed/locations/${id}?web-key=0V3ND-dzGvrv',
  youtubeUrl: 'https://www.youtube.com/embed/${code}',
  maxLocationFeedLimit: 30,
  eventImageSizeLimit: 1024 * 1024 * 2,
  eventbrite: 'eventbrite',
  phoneSizeWidth: 1100,
  exSmallphoneSizeWidth: 300,
  smallPCSizeWidth: 1800,
  smallestPCSizeWidth: 1280,
  calendarCardSquareWidth: 295,
  calendarCardLongWidth: 336,
  calendarCardDefaultWidth: 300,
  searchLimit: 9999999, // use limit=0 in MongoDB search sometimes causes problems
  placeSearchLimit: 1000,
  compressImgWidth: 1200,
  // compressImgWidthBig: 1200,
  isAnalyticsOn: false,
  hidePromotionImageForPlaces: ['AdventureCoast'],
  placeSocialName: ['facebook', 'google'],
  emailPattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
  placeDefaultImages: {
    Accommodations: [
      'assets/imgs/placedefault/accommodation/accommodation1.jpg',
      'assets/imgs/placedefault/accommodation/accommodation2.jpg',
      'assets/imgs/placedefault/accommodation/accommodation3.jpg',
      'assets/imgs/placedefault/accommodation/accommodation4.jpg',
      'assets/imgs/placedefault/accommodation/accommodation5.jpg',
      'assets/imgs/placedefault/accommodation/accommodation6.jpg',
      'assets/imgs/placedefault/accommodation/accommodation7.jpg',
      'assets/imgs/placedefault/accommodation/accommodation8.jpg',
      'assets/imgs/placedefault/accommodation/accommodation9.jpg',
      'assets/imgs/placedefault/accommodation/accommodation10.jpg',
    ],
    'Dining & Nightlife': [
      'assets/imgs/placedefault/dining/dining1.jpg',
      'assets/imgs/placedefault/dining/dining2.jpg',
      'assets/imgs/placedefault/dining/dining3.jpg',
      'assets/imgs/placedefault/dining/dining4.jpg',
      'assets/imgs/placedefault/dining/dining5.jpg',
      'assets/imgs/placedefault/dining/dining6.jpg',
      'assets/imgs/placedefault/dining/dining7.jpg',
      'assets/imgs/placedefault/dining/dining8.jpg',
      'assets/imgs/placedefault/dining/dining9.jpg',
      'assets/imgs/placedefault/dining/dining10.jpg',
    ],
    'Arts & Culture': [
      'assets/imgs/placedefault/art/art1.jpg',
      'assets/imgs/placedefault/art/art2.jpg',
      'assets/imgs/placedefault/art/art3.jpg',
    ],
    Shopping: [
      'assets/imgs/placedefault/shopping/shopping1.jpg',
      'assets/imgs/placedefault/shopping/shopping2.jpg',
      'assets/imgs/placedefault/shopping/shopping3.jpg',
    ],
    Activities: [
      'assets/imgs/placedefault/activity/activity1.jpg',
      'assets/imgs/placedefault/activity/activity2.jpg',
      'assets/imgs/placedefault/activity/activity3.jpg',
    ],
    'Outdoors & Fitness': [
      'assets/imgs/placedefault/outdoor/outdoor1.jpg',
      'assets/imgs/placedefault/outdoor/outdoor2.jpg',
      'assets/imgs/placedefault/outdoor/outdoor3.jpg',
    ],
    Entertainment: [
      'assets/imgs/placedefault/entertainment/entertainment1.jpg',
      'assets/imgs/placedefault/entertainment/entertainment2.jpg',
      'assets/imgs/placedefault/entertainment/entertainment3.jpg',
    ],
    Transportation: [
      'assets/imgs/placedefault/transportation/transportation1.jpg',
      'assets/imgs/placedefault/transportation/transportation2.jpg',
      'assets/imgs/placedefault/transportation/transportation3.jpg',
    ],
    Other: [
      'assets/imgs/placedefault/other/other1.jpg',
      'assets/imgs/placedefault/other/other2.jpg',
      'assets/imgs/placedefault/other/other3.jpg',
    ],
  },
  tripPlanner: {
    placeCategoryStartPage: 'assets/imgs/place-category-start.jpg',
    detailsPreview: 'assets/imgs/side-float.jpg',
    sideFloatView: 'assets/imgs/side-float-view.jpg',
    popupView: 'assets/imgs/popup-view.jpg',
    tripImages: [
      'assets/imgs/trips/trip1.jpg',
      // 'assets/imgs/trips/trip2.jpg',
      // 'assets/imgs/trips/trip3.jpg',
      // 'assets/imgs/trips/trip4.jpg',
    ],
    maxTripCount: 12,
    eventMapIcon: 'assets/imgs/trips/Events-PNG.png',
    placeMapIcon: {
      accommodation: 'assets/imgs/trips/Accommodations-PNG.png',
      arts: 'assets/imgs/trips/Arts-PNG.png',
      dinging: 'assets/imgs/trips/Dining-PNG.png',
      activity: 'assets/imgs/trips/Activities-PNG.png',
      shopping: 'assets/imgs/trips/Shopping-PNG.png',
      outdoor: 'assets/imgs/trips/Outdoors-PNG.png',
      entertainment: 'assets/imgs/trips/Entertainment-PNG.png',
      transportation: 'assets/imgs/trips/Travel-PNG.png',
      other: 'assets/imgs/trips/Other-PNG.png',
    },
  },
  PDF: {
    restrictImageRatio: false,
    PDFTopEventBackgroundImage: 'assets/imgs/default_event.jpg', //'assets/imgs/pdf-top.jpg',
    PDFTopPlaceBackgroundImage: 'assets/imgs/default_place.jpg', //'assets/imgs/pdf-top-place.jpg',
    PDFTopTripBackgroundImage: 'assets/imgs/default_trip.jpg',
    PDFLogoBackgroundWhiteImage:
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAeAB4AAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCACcAcYDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigD/9k=',
    PDFOwnerImage:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAMAAACKeiw+AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAFRQTFRFAAAAma2b6+/sobOizNbNm66du8i8nbCforSjoLKhqbqrztjPpren8fTx1d3WwMzB7fHttMK17PDt6e3p5enl8PPwxtLIxM/Ft8W4ydTK5+vnpLWlG/GaDwAAABx0Uk5TAP///////////////2b//83/5v//gP///////+xpd7EAAACdSURBVHictdLZDoMgEEDRGVEWxX23//+fRWyUTWzS9L6ehDAwAF+XLAJRLElYC4Y6VoQ0zfBTlvq6cTzjm8cUjajHucm5qx03mXfuUMRk4g0XP/zpaoO4VAz+4PFneXpUgJGq6xM6hvW/NVWqqpoA9bW8BnvVvYWT9SH6U6YTV+aiHn89tA3hXrvrfKeIM0Ap71mWzh7Yqa34jeO9AV5bBQo+oNNjAAAAAElFTkSuQmCC',
    PDFVenueImage:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEJQTFRFma2bAAAA09XV1L+anL/YtsK4mq21+9i0m7m+0caq4tC4mq2rt8LPv9XVtbqkmrOuu7ma5///1eHy8OHV09Xi9P//tdtHhwAAABZ0Uk5T/wD///////////////////8Z////GZRGMhMAAABqSURBVHicY2BmQAVsjOiAgWpKOJhggBOXEhY4j50CJSgWcfMyoQIhDOdiABbqKcHjXGaqKuFnhQE+iBIuMIdHEKEEI46YkVnEKsFlEdV9RIQS6viICCUYaVcYzBERpbaP8KRdAaomTAJKAIXTBbmtgiWsAAAAAElFTkSuQmCC',
    PDFMapMarkerImage:
      'data:image/png;base64,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', //'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAAoACEDASIAAhEBAxEB/8QAHAAAAgIDAQEAAAAAAAAAAAAAAAcBAgMGCAQJ/8QAKxAAAQMEAAQFBAMAAAAAAAAAAQIDBAAFBhEHEiExCBNBUWEiQnGhFVKB/8QAGgEAAgMBAQAAAAAAAAAAAAAAAAUCAwYEB//EACcRAAEEAgEDAgcAAAAAAAAAAAECAwURAAQhBjFBEhQiMlFxgZGh/9oADAMBAAIRAxEAPwD6oEgdT3pfZ5xrwzAZX8ZPeelzwAVRoqQpSAe3MSQBv23v41W2ZZdl2LGbpem0c6oMN6QE+5Qgq1+qS/hzwy0Xq3zc+vrKJ91lTXA24+AvyiOpUAfuKiTvvrWtdd5Wckt1O2zGR1BxwFRUrkJSmuw8nODaedDiWGKCjZs+AM2XFvEhgeR3BFtkJlWp148ra5aUhtRPYFSSQCfnQ+aa6SFDmSd7pZ8cMCx6/wCEXW7uwGW7hbYq5TElCAHNISVFOx1IIBGvmsvh/wAjm5Dw3hLuLinH4a1xC4odVpQfpPzpJA366qqMkJDWkjEySgslPqSpIqwDRBH1yDDzzb/t3yCSLBAr9jGXRVeY0VrqxlnmuMJm4wH4EhAU1JaU0tJ9QoEEfs1ylhfEe98DMhuuH3i3LlwESiVtghLiD9rjexpQUkJOjodjsdd9bEe4pI+IjhYvJLeMusUUruUBGpDaO77A67A9VJ6n5Gx1OhWE63j91TKJWMJD7FkVzaT3FfjFEqy8UDY1zS0f0ec0Xif4hXMztDmNYzan4kaaPLfdeI81wbH0JSkkAHsTskjpoU+OE+KKw3BLXZHkkSEtedI3381Z5lD/AAq1+AKQ/h24Wu326t5teoxFugL5oaVjo+8D0UN9wgje/wCwHsa6nSAAPal/QmvJSS1z0sfjWPSgVVJ7njxeUxCH3ydzZ+Y8D7ZbZ9qKjmor0zHuWqCARo0UUYZiYjsxm0tR2UNNpGghCQkD8AdKygaooqISEihgOMmiiipYZ//Z',
    PDFTimerImage:
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAAlACYDASIAAhEBAxEB/8QAGwABAAIDAQEAAAAAAAAAAAAAAAEHBAUGAgn/xAAmEAABAwQBBAIDAQAAAAAAAAABAAIDBAUGERIhMUFRExQHImFx/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAIDAf/EABsRAQEBAQEBAQEAAAAAAAAAAAEAAhEhMQMS/9oADAMBAAIRAxEAPwD6pqCdKVXt7umQ5dlNRiGOXB1toLaxpulfENylzhtsUZPQHWyT10tydZda/msAFelU9vwajnu92t1gyfIaK5Wh0QFVJXumbI57OQ5Md0I8ELqcCye5XlldZcghbHeLLMKer4dGS7G2yNHgOGjpM458ZM/p14nLr0RElWg+var3DqmKy53k+PV5+Opr6hlxpS7p88Rbp2j54ka0rCI2tBlOG2XLYY23GOSOopzyp6qB5jmhd7a4dR/nYrcoeU9i8T6WpmtF1xrKJcitjPvUV1e1tfAABLF4bI07HIDsQew7LDwWoZfc2ynJaEboC6ChilHad0bf2cD5AJ47/iO/FldWM+pec+vtbQ9jT82x82+nOaNkLtbXbKCzUMVstlKynpoG8Y42DQATqB56yZyuvThZqIinXiIiIiIiIiIiIv/Z',
    PDFCategoryImage:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAVCAYAAADM+lfpAAAAOElEQVR42mP4P4gAA4iYPGUqCkYG6HK0wqOOGVqOGVQJeNQxo1l71DGjWXs0a48m4FHHjGZt0gAAejStpHZTC6AAAAAASUVORK5CYII=',
    PDFWebImage:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAIAAACZeshMAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACRSURBVDhPY/j///+v37+u3Lt+8tpZIhFQMVALUCPDl+9fl+5aPWXtbJIQUAtQI8OtR3dmbJiPJkcQAbUANQ645lX71r96/wYXOnrpBLICIBtF89oDm4ChhwucvXEBWQGQPUg0T18/d87mRbjQzI0LaGbzwGmes3nx+kNbcCFgSkZWAGRDNVOUMYDOIDNL/v8PAAVz9B7PzHutAAAAAElFTkSuQmCC',
    PDFPhoneImage:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFLSURBVDhPjZPtT4JQFIf5/z9X1hLZKqppiCz9UDRptrmV07XYyuxlaCsqIc1Fmij1o3NHRoE8O7Bxzn3uy7mD8zzvZdB77lkUw4/RZwK4ZvsqVcgsSKsUW6qUxORanevlghBoG3vZt6HDitGEtUxJxJ5ZMRoO50nvrgUapsBErBgN54zexf1coC3lef3mnBWj4fCoNS1wtMYReku1GHzt9sFYUYTkDvA1d+LmNAWrVfVjys7F1wD1ky+u33dNysTDNOxNrR1iQbRn4AwoGQPTwNgdy5UizB1NcWZuHDMaZsfq2+z7mx8NYB26DLy7fQsZOOgTuoVkSuZxw5tqDlf9SwMws2UZg9Dbqn5SrlfImY1G6yysAewW5/w7Ooh68/QfjWg/3m0fSCGBIk4jTPsJKwslcTGfJiclZy6MyzlawGQ6tV5tNAP/h+d5X0YnY2ggBsChAAAAAElFTkSuQmCC',
    PDFPriceImage:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAIAAAAym6IDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFTSURBVDhPnZP9S8JAHMb7/38uRM23WmYvvkw2SzSJVCxKIpGkoHwpMW2pjIblYtfT9sXd7Cro4fhyPHcf7nvPbSvsmyzLGuuT0URDxZxcTgLmdWZI+d3VZBAVc3I5CRht+rJxmACDiqPI5eRhZu9vSjW/lloH4AxfOlS8OJ6bc9phy2XQerZygH2BbKxUL59d11Exh1NrntMmWy6DlkLKpi8dbnVuyGLs8raBY7cLSbRAlpBp3rfIYgxdwV8K0GXMDzNzoqITvxwpX9UMUWKOPBnohr5Xyji3xwgrUrVxynflyMNA6KE96OJA5/ZfpCp1Bj1atrXMLAT4rt+O5uLA4oV9cQbC6/aGjwE56pej/FEuAxdrwWzsYdgn609mkVtE3UJueFNUzOEkij+8D4R85UqO/3Ywdo5Sz1ONdtgSZMB/o0/jEbmcBMx//gXk9ts/x9gnm25AbKEh0EIAAAAASUVORK5CYII=',
    PDFCheckinsImage:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAUCAIAAADp3DFZAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEySURBVDhPzZPrS8JQHIb7/z8X3UTRoouga87mBLtOqb4YRlCZgVaKLm/pzFTYes92lJ11ltX60MvzYfwuD9vhbMH8i3zLMp6Mk7m0cnGAB1piM9+CTSmnLMbWQb54Rats5liciqV4oFC6pg02X1mcCrCWCD9rNdpj42lxKcBGerf/ptM2G74FitR5xqkA8ROJtj+Fb1ELZy4FCKe2hdOkEzErV+pPmCeWh2o5JG8FpAjAV6ASO064FF5gsdPvEkvxsbSyF7Kr2P+RBYtY/x8WHEKj/eLXIqqyYRi+LMtC8KZ8h3lfluihgJvly4Lf6nL6c/7eElF2eoOeJfGw4FLOpr04yquWgYRvua3cr4q0wiW4v1lva5aBhFhwQs1uS+s0watOX1IfDuwKl+Ho3R4jMc0PqahTAo9FdaQAAAAASUVORK5CYII=',
  },
  columns: {
    events: [
      'Title',
      'StartTime',
      'StartTimeISO',
      'EndTime',
      'EndTimeISO',
      'Image',
      'Description',
      'Venue',
      'Address',
      'TicketURI',
      'Link',
      'Organizer',
      'OrganizerLink',
    ],
    places: [
      'Title',
      'Category',
      'Image',
      'Description',
      'Address',
      'Email',
      'Phone',
      'Website',
      'Rating',
      'PriceRange',
      'Link',
      'GooglePlaceId',
      'ApprovalStatus',
    ],
  },
  exportFilename: {events: 'Events', places: 'Places'},
  dayOfWeek: [
    {name: 'Sunday', short: 'Sun'},
    {name: 'Monday', short: 'Mon'},
    {name: 'Tuesday', short: 'Tue'},
    {name: 'Wednesday', short: 'Wed'},
    {name: 'Thursday', short: 'Thu'},
    {name: 'Friday', short: 'Fri'},
    {name: 'Saturday', short: 'Sat'},
  ],

  mileToMeters: 1609,
  port: 8080,
  facebook: {
    sdkConfig: {
      appId: '252327515144523',
      autoLogAppEvents: true,
      xfbml: false,
      version: 'v15.0',
    },
    graphApi: {
      scope: 'public_profile', //'user_events', //'rsvp_event,user_events',
      profile: 'https://www.facebook.com/${userId}',
      profilePicture: 'https://graph.facebook.com/${userId}/picture?type=normal',
      profilePictureSquare: 'https://graph.facebook.com/${userId}/picture?type=square',
      attendEvent: '${eventId}/attending',
      leaveEvent: '${eventId}/declined',
      events: '${userId}/events/attending',
      placePosts:
        '${placeId}/posts?access_token=${accessToken}&fields=permalink_url,message,updated_time,picture,actions,from,story,full_picture&limit=10',
      eventPosts:
        '${eventId}/feed?access_token=${accessToken}&fields=message,updated_time,picture,actions,from,story&limit=5',
    },
    logo: 'assets/imgs/facebook.png',
    approvedApps: [
      '252327515144523|c60c9112f5cceb32e279ea060522dd97', // frontend
    ],
  },
  google: {
    // :'AIzaSyAjcpYRF3EQc-LBw5w2_lpzKKeEBDiGLcM',//'AIzaSyBpVhnOF4Ro54dM6kC6AFhboa_lmU7WXiY',//,
    appKeys: [
      'AIzaSyBTK-7XADsofCdPvDWP4Rh2QzSK6t-POaw',
      'AIzaSyCJolWCJpnbwVApKEPgWcuadMsJf2lm3Go',
      // 'AIzaSyCe_U6wUJnTy5Jgk9vlqMPZz-dpivfF8-4',
      // 'AIzaSyAjcpYRF3EQc-LBw5w2_lpzKKeEBDiGLcM',
      // 'AIzaSyBpVhnOF4Ro54dM6kC6AFhboa_lmU7WXiY'
    ],
    paths: {},
    USCenter: {
      lat: 40.030979347,
      lng: -96.85546875,
    },
    fullUSMapZoom: 4,
    locationMapZoom: 10,
    iconUrl: 'assets/imgs/marker.png',
    hideMapBusinessIconStyles: [
      {
        featureType: 'poi.business',
        stylers: [{visibility: 'off'}],
      },
      {
        featureType: 'transit',
        elementType: 'labels.icon',
        stylers: [{visibility: 'off'}],
      },
    ],
    navigation: 'https://www.google.com/maps/dir/${GPS}/${addresses}',
    navigationShort: 'maps/dir/${GPS}/${addresses}',
    navigationApi:
      'https://www.google.com/maps/dir/?api=1&origin=|GPS|&destination=${addresses}&travelmode=${mode}&dir_action=navigate',
    navigationApiShort:
      'origin=${GPS}&destination=${destination}&waypoints=${waypoints}&travelmode=${mode}&dir_action=navigate',
    placePhotoThumb:
      'https://maps.googleapis.com/maps/api/place/photo?maxwidth=480&photoreference=${photo_reference}&key=${appKey}',
    placePhoto:
      'https://maps.googleapis.com/maps/api/place/photo?maxwidth=480&photoreference=${photo_reference}&key=${appKey}',
    placeRealPhotoThumb: 'https://lh3.googleusercontent.com/p/${short_reference}=s1600-w480',
    placeRealPhoto: 'https://lh3.googleusercontent.com/p/${short_reference}=s1600-w480',
  },
  eventShare: {
    mailDateFormat: 'dddd MMM, D, YYYY [at] h:mm a',
    mailTo:
      'mailto:?subject=${subject}&body=${body}%0D%0A%0D%0AStart at: ${startTime}%0D%0A%0D%0AOrganizer: ${owner}%0D%0A%0D%0A${url}',
    tweet: 'https://twitter.com/share?text=${text}&url=${url}',
    googleMapGetDirection: 'https://maps.google.com?q=${address}',
  },
  placeShare: {
    mailTo:
      'mailto:?subject=${subject}&body=${body}%0D%0A%0D%0ACategory: ${category}%0D%0A%0D%0AAddress: ${address}%0D%0A%0D%0A${url}',
  },
  tripShare: {
    mailTo: 'mailto:?subject=Check out my trip plan&body=Check out my trip plan! ${url}',
  },
  tourShare: {
    mailTo: 'mailto:?subject=Check out this itinerary&body=Check out this itinerary! ${url}',
  },
};

if (process.argv.indexOf('production') !== -1) {
  mergeDeep(config, localConfig);
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/config/config.ts